import { useRouter } from 'next/router';

export const useGetCurrentTab = () => {
	const router = useRouter();
	const { tab, id } = router.query;

	return {
		id: id?.toString(),
		tab: tab?.toString(),
	};
};
